const manifest = {
    "images": [
        "buza.webp",
        "boci.webp",
        "kakas.webp",
        "paprika.webp",
        "alma.webp",
    ]
}

export default manifest;